import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPosPriorityChangeRequest } from '../models/models'
import { CommonPostResponse } from '../../../components/models/models'

export class ChangeVodafoneDisablePOSApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransaction/changeVodafoneDisablePOS',
      requesterInfo,
    })
  }

  public async changeVodafoneDisablePOS(request: IPosPriorityChangeRequest): Promise<any> {
    return await this.postAsync<IPosPriorityChangeRequest>(request)
  }
}